import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import vi_json from './translations/vi/translation.json';
import en_json from './translations/en/translation.json';
import backend from "i18next-http-backend";
import Service from 'src/UIS_services/LanguageService/LanguageService';

const loadResource = async (param: string) => {

    try {
        let res = await Service.GetResourceLanguage(param);

        const obj = {}

        res.forEach(element => {
            if (!obj[element.ComponentID])
            obj[element.ComponentID] = {}
            obj[element.ComponentID][element.KeyLanguage] = element.Description
        });
        // console.log(obj);

        return obj;
    } catch (error) {
        console.log(error)
    }
}

const backendOptions = {

    loadPath: '{{lng}}|{{ns}}',
    request: (options: any, url: any, payload: any, callback: any) => {
        try {
            const [lng] = url.split('|');
            loadResource(lng).then((response) => {
                callback(null, {
                    data: response,
                    status: 200,
                });
                // console.log(response);
            });
        } catch (e) {
            console.error(e);
            callback(null, {
                status: 500,
            });
        }
    },
};

i18n
    .use(backend)
    .use(initReactI18next)
    .init({
        backend: backendOptions,
        //resources,
        lng: 'vi',
        fallbackLng: 'vi',
        debug: false,
        //keySeparator: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            wait: true,
            useSuspense: true,
            bindI18nStore: "added"
        }
    });




